import { Injectable, inject } from '@angular/core';
import { EMPTY, of, switchMap, withLatestFrom } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map } from 'rxjs/operators';
import { ProductGatewayService } from '../gateway/product.gateway';
import * as ProductActions from '../actions/product.action';
import { loadProduct } from '../actions/product.action';
import { ProductState } from '../reducers/product.reducer';
import { selectProductState } from '../selectors/product.selector';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'any',
})
export class ProductEffects {
  private actions$ = inject(Actions);
  private productConnector = inject(ProductGatewayService);
  private store = inject<Store<ProductState>>(Store);

  getProduct$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductActions.GET_PRODUCT),
      withLatestFrom(this.store.select(selectProductState)),
      switchMap(([{ culture, productCode }, productState]) => {
        if (!productState.entities?.[culture]?.[productCode]) {
          return of(loadProduct({ culture, productCode }));
        }
        return EMPTY;
      }),
    );
  });

  loadProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.LOAD_PRODUCT),
      switchMap((action) =>
        this.productConnector.getProduct(action['productCode']).pipe(
          map((data) =>
            ProductActions.loadProductSuccess({
              culture: action['culture'],
              product: data,
            }),
          ),
          catchError((errorMessage) => {
            return of(ProductActions.loadProductFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );
}
